<header
  *ngIf="azienda"
  class="header-class card-container"
  aria-label="logo azienda sanitaria"
>
  <div class="logo-container-albi">
    <img
      src="{{ logoImg }}"
      [attr.alt]="'Logo aziendale ' + azienda.nome"
      class="logo-img-albi"
    />
  </div>
  <div class="text-green-albi">
    <div *ngIf="albo.specifica !== 'LEGGE190' && !(albo.tipo === 'PROVVEDIMENTI' && albo.azienda === 'aouivr')">
      {{
        albo.tipo.replace("_", " ") +
          (albo.specifica != null ? " " + albo.specifica.replace("_", " ").replace("_", " ") : "") +
          " On Line " | titlecase
      }}
    </div>
    <div *ngIf="albo.tipo === 'PROVVEDIMENTI' && albo.azienda === 'aouivr'">
      {{
        "Provvedimenti " +
          (albo.specifica != null
            ? albo.specifica === "DIRIGENTI"
              ? " dirigenti amministrativi"
              : " organi indirizzo politico"
            : "") +
          " On Line "
      }}
    </div>
    <div *ngIf="albo.specifica === 'LEGGE190'">
      {{ (albo.specifica != null ? " " + albo.specifica.replace("_", " ").replace("_", " ") : "") + " On Line " | titlecase }}
    </div>
    <!-- PROGRESS SPINNER -->
    <span>
      <span *ngIf="exportCsvInProgress2">
        <p-progressSpinner
          [style]="{ width: '1em', height: '1em', marginRight: '0.438rem' }"
          strokeWidth="8"
          fill="#FFFFFF"
          animationDuration=".5s"
        >
        </p-progressSpinner>
      </span>
      <!-- BOTTONE ESPORTA -->
      <button
        type="button"
        pButton
        pRipple
        icon="pi pi-file-o"
        label="Esporta"
        (click)="listComponent.exportCSV2()"
        pTooltip="CSV"
        aria-label="Scarica il csv della tabella"
        tooltipPosition="bottom"
      ></button>
    </span>
  </div>
</header>
<div style="height: 0.13rem; background-color: #048d4f9c"></div>
<div style="height: 0.6rem; background-color: #ffffff"></div>

<p-splitter
  styleClass="splitter-pubblicazioni"
  [panelSizes]="[60, 40]"
  [minSizes]="[50, 30]"
  [ngClass]="{ hiderightside: !showRightSide }"
>
  <ng-template pTemplate>
    <app-pubblicazioni-list
      #list
      class="pubblicazioni-list"
      [albo]="albo"
      (showRightPanel)="manageRowSelected($event)"
      (showSpinning)="showSpinningClass($event)"
      ><!--  [azienda]="azienda"  -->
    </app-pubblicazioni-list>
  </ng-template>
  <ng-template pTemplate>
    <app-pubblicazione-detail
      *ngIf="showRightSide"
      [pubElement]="pubblicazioneElement"
      [albo]="albo"
      (closeRightPanel)="manageRowSelected({ showPanel: false, rowSelected: null })"
    >
    </app-pubblicazione-detail>
  </ng-template>
</p-splitter>
